export const ERROR = 'ERROR'
export const MESSAGE = 'MESSAGE'
